export default {
  theme: {
    fontFamily: {
      sans: ['Archivo', 'Helvetica', 'sans-serif'],
      hero: ['VTC Bayard Rustin', 'Helvetica', 'sans-serif']
    },    
    extend: {
      colors: {
        semantic: {
          primary: {
            default: '#671CC2',
            'variant-light': '#361564',
            'variant-highlight': '#614983',
            'variant-dark': '#1E0C39',
            'on-default': '#FFFFFF',
            'on-light': '#FFFFFF',
            container: '#EFE8F8'
          },
          secondary: {
            default: '#671CC2',
            'variant-light': '#361564',
            'variant-highlight': '#614983',
            'variant-dark': '#1E0C39',
            'on-default': '#FFFFFF',
            'on-light': '#FFFFFF'
          },
          surface: {
            default: '#FFFFFF',
            'on-surface': '#1E0C39',
            'on-surface-variant': '#8C8C89',
            container: '#E2E1E0',
            'container-variant': '#FAFAFA',
            'container-variant-low': '#F9F9F9',
            'container-lowest': '#FBF7FF',
            'container-low': '#EFE8F8',
            'container-high': '#E1D2F3'
          },
          inverse: {
            surface: '#1E0C39',
            'surface-light': '#361564',
            'on-surface': '#FFFFFF',
            primary: '#CBFE50',
            'on-primary': '#1E0C39',
            'primary-variant': '#E2FFA4',
            'primary-variant-light': '#F0FFD1',
            'on-primary-variant': '#1E0C39',
            'container-lowest': '#614983'
          },
          outline: {
            default: '#C5C5C2',
            variant: '#E2E1E0',
            'variant-dark': '#1E0C39',
            'variant-light': '#F4F4F4',
            'white': '#FFFFFF'
          },
          states: {
            info: {
              default: '#0057AC',
              variant: '#E5ECFB',
              container: '#B8CBF4',
              'variant-dark': '#003E7A',
              'variant-darkest': '#002447',
              'on-default': '#FFFFFF',
              'on-variant': '#003E7A',
              'on-variant-light': '#FFFFFF'
            },
            error: {
              default: '#A3000B',
              variant: '#FCE8EC',
              'on-default': '#FFFFFF',
              'on-variant': '#700007'
            },
            warning: {
              default: '#CC7700',
              variant: '#FFFCE5',
              'on-default': '#FFFFFF',
              'on-variant': '#663B00'
            },
            success: {
              default: '#0D7A12',
              variant: '#E5FAE6',
              'on-default': '#FFFFFF',
              'on-variant': '#084A0B'
            },
            disabled: {
              default: '#F1F0F0',
              'on-default': '#8C8C89'
            }
          },
          util: {
            transparent: '#ffffff00'
          },
          vertical:{
            finance:{
              base: '#FFC682',
              low: '#FFDDB4'
            },
            insurance:{
              base:'#59FFD7',
              low:'#A3FFE9',
              lowest:'#F7FFFD'
            }
          }
        },
        base: {
          lavender: {
            lavender: '#671CC2',
            900: '#7733C8',
            800: '#8549CD',
            700: '#9561D4',
            600: '#A477DA',
            500: '#B38DE0',
            400: '#C2A4E6',
            300: '#D1BAEC',
            200: '#E1D2F3',
            100: '#EFE8F8',
            50: '#FBF7FF'
          },
          neutral: {
            neutral: '#191A19',
            900: '#353735',
            800: '#525351',
            700: '#8C8C89',
            600: '#A9A9A6',
            500: '#C5C5C2',
            400: '#D4D3D1',
            300: '#E2E1E0',
            200: '#F1F0F0',
            100: '#FAFAFA',
            0: '#FFFFFF'
          },
          purple: {
            'deep-purple': '#1E0C39',
            purple: '#361564',
            900: '#4D3274',
            800: '#614983',
            700: '#745F93',
            600: '#8876A2',
            500: '#9C8DB1',
            400: '#B0A4C1',
            300: '#C4BBD0',
            200: '#D7D1E0',
            100: '#EBE8EF'
          },
          lime: {
            lime: '#CBFE50',
            900: '#D3FF76',
            800: '#D8FF85',
            700: '#DDFF95',
            600: '#E2FFA4',
            500: '#E7FFB3',
            400: '#EBFFC2',
            300: '#F0FFD1',
            200: '#F5FFE1',
            100: '#FAFFF0'
          },
          mint: {
            seafoam: '#59FFD7',
            mint: '#A3FFE9',
            900: '#7AFFDF',
            800: '#9BFFE7',
            600: '#B4FFED',
            500: '#CDFFF3',
            400: '#DEFFF7',
            300: '#E6FFF9',
            200: '#EEFFFB',
            100: '#F7FFFD'
          },
          rose: {
            pink: '#FF83E7',
            rose: '#FFC9FA',
            900: '#FF9CEC',
            800: '#FFB5F1',
            700: '#FFC1F3',
            500: '#FFDAF8',
            400: '#FFE6FA',
            300: '#FFECFB',
            200: '#FFF3FD',
            100: '#FFF9FE'
          },
          oat: {
            oat: '#FFFAF3',
            tangerine:'#FFC682',
            900: '#FFCC8F',
            800: '#FFD19B',
            700: '#FFD7A7',
            600: '#FFDDB4',
            500: '#FFE3C1',
            400: '#FFE8CD',
            300: '#FFEED9',
            200: '#FFF4E6'
          }
        }
      },
      boxShadow: {
        'elevation-1': '0 0.0625rem 0.25rem 0 #391b641a',
        'elevation-2': '0 0.0625rem 0.125rem 0 #391b6433',
        'elevation-3': '0 0.25rem 0.75rem 0.1875 #391B641A',
        'combined-elevation-1': '0px 1px 2px 0px #391B6433, 0px 1px 4px 0px #391B641A',
        'combined-elevation-2': '0px 2px 8px 2px #391B641A, 0px 1px 2px 0px #391B644D',
        'combined-elevation-3': '0 4px 12px 3px #391B641A, 0 1px 3px 0 #391B6466'
      }
    }
  }
}
